import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import axios from "axios";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { centralizedHost } from "~/Utils";
import { appendSasToken } from "../Imagehelper";
import { useCentralisedBannerDetails } from "./Banner.hook";
import { fields } from "./constants";
export const AddEditCentralizedBanner = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useCentralisedBannerDetails(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const [records, setRecords] = useState<any[]>([]);

  const getRecords = () => {
    let url = `${centralizedHost}/api/homepage-banner/all-fields`;
    axios
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setRecords(envelopes);
        }
      })
      .catch(() => {
        setRecords([]);
      });
  };

  useEffect(() => {
    getRecords();
  }, []);

  const HomepageFormConfig: FormConfig = {
    initialValues: {
      published: dataById
        ? decodeHTML(dataById.payload?.published)
        : editData
          ? decodeHTML(editData?.published)
          : false,

      sequence: dataById ? decodeHTML(dataById.payload.sequence) : editData ? decodeHTML(editData?.sequence) : "",
      tag: dataById ? decodeHTML(dataById.payload.tag) : editData ? decodeHTML(editData?.tag) : "",
      type: dataById ? decodeHTML(dataById.payload.type) : editData ? decodeHTML(editData?.type) : "",
      project_airport_id: dataById
        ? decodeHTML(dataById.payload.project_airport_id)
        : editData
          ? decodeHTML(editData?.project_airport_id)
          : "",
      start_date: dataById ? decodeHTML(dataById.payload.start_date) : editData ? decodeHTML(editData?.start_date) : "",
      end_date: dataById ? decodeHTML(dataById.payload.end_date) : editData ? decodeHTML(editData?.end_date) : "",
      title: dataById ? decodeHTML(dataById.payload.title) : editData ? decodeHTML(editData?.title) : "",
      title_malay: dataById
        ? decodeHTML(dataById.payload.title_malay)
        : editData
          ? decodeHTML(editData?.title_malay)
          : "",
      title_mandarin: dataById
        ? decodeHTML(dataById.payload.title_mandarin)
        : editData
          ? decodeHTML(editData?.title_mandarin)
          : "",

      redirect_url: dataById
        ? decodeHTML(dataById.payload.redirect_url)
        : editData
          ? decodeHTML(editData?.redirect_url)
          : "",

      web_image: dataById
        ? dataById?.payload?.web_image
          ? [
              {
                uid: "-1",
                name: "web_image.jpg",
                status: "done",
                url: appendSasToken(dataById?.payload?.web_image),
              },
            ]
          : []
        : editData?.web_image
          ? [
              {
                uid: "-1",
                name: "web_image.jpg",
                status: "done",
                url: appendSasToken(editData?.web_image),
              },
            ]
          : [],

      image: dataById
        ? dataById?.payload?.image
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: appendSasToken(dataById?.payload?.image),
              },
            ]
          : []
        : editData?.image
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: appendSasToken(editData?.image),
              },
            ]
          : [],

      tab_image: dataById
        ? dataById?.payload?.tab_image
          ? [
              {
                uid: "-1",
                name: "tab_image.jpg",
                status: "done",
                url: appendSasToken(dataById?.payload?.tab_image),
              },
            ]
          : []
        : editData?.tab_image
          ? [
              {
                uid: "-1",
                name: "tab_image.jpg",
                status: "done",
                url: appendSasToken(editData?.tab_image),
              },
            ]
          : [],

      video: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "video.mp4",
              status: "done",
              url: appendSasToken(dataById?.payload?.video),
            },
          ])
        : editData?.video
          ? decodeHTML([
              {
                uid: "-1",
                name: "video.mp4",
                status: "done",
                url: appendSasToken(editData?.video),
              },
            ])
          : "",
    },
    // fields: fields.centralizedBanner,

    fields: fields.centralizedBanner.map((field: any) => {
      // if (field.name === "sequence") {
      //   return {
      //     ...field,
      //     validation: {
      //       required: `${field.label || field.name} is required`,
      //       validate: (value: string, formValues: FieldValues) => {
      //         if (!value) return true;
      //         const existingRecord = records.find((record: any) => {
      //           return (
      //             toInteger(record[field.name]) === toInteger(value) &&
      //             record.id !== (editData?.id || dataById?.payload?.id)
      //           );
      //         });
      //         return !existingRecord || `${field.label || field.name} already exists`;
      //       },
      //     },
      //   };
      // }

      if (field.name === "sequence") {
        return {
          ...field,
          validation: {
            required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;

              const selectedAirports = formValues.project_airport_id || [];

              const existingRecord = records.find((record: any) => {
                const sameSequence = toInteger(record.sequence) === toInteger(value);

                const isSameRecord = record.id === (editData?.id || dataById?.payload?.id);

                const airportOverlap = record.project_airport_id?.some((airportId: string) =>
                  selectedAirports.includes(airportId)
                );

                return sameSequence && airportOverlap && !isSameRecord;
              });

              return !existingRecord || `${field.label || field.name} already exists for selected airport`;
            },
          },
        };
      }

      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image", "web_image", "tab_image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CENTRALIZED");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          const cleanUrl = field[0].url.split("?sp=")[0];
          data[key] = cleanUrl;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    if (data.video && data.video.length > 0) {
      const file = data.video[0];
      if (file.originFileObj) {
        // new upload
        const formData = new FormData();
        formData.append("upload-file", file.originFileObj);
        formData.append("application", "CENTRALIZED");
        const res: any = await post("management/upload-file", formData);

        if (res) {
          data.video = res.response.data;
        }
      } else {
        // existing file
        data.video = file.url || "";
      }
    } else {
      data.video = "";
    }

    const formattedData = {
      ...data,
      ...(data.start_date && { start_date: data.start_date.replace("T", " ") }),
      ...(data.end_date && { end_date: data.end_date.replace("T", " ") }),
    };

    const payload = {
      action: action,
      method: method,
      module: "Centralized Banner",
      subModule: `centralizedBanner`,
      type: "CENTRALIZED",
      application: "CENTRALIZED",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "CENTRALIZED",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "CENTRALIZED_Banner",
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...formattedData,
        created_by: action === "UPDATE" ? editData?.created_by || dataById?.payload?.created_by : user?.email,
        last_modified_by: action === "UPDATE" ? user?.email : null,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Centralized Banner`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={HomepageFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === "update"
              ? `${centralizedHost}/api/homepage-banner/${editData?.id || dataById?.payload?.id}`
              : `${centralizedHost}/api/homepage-banner`,
            query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE",
            query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Banner"
        enableDynamicWatch={true}
      />
    </ContentWrapper>
  );
};
